import { request } from './client';
import type {
  Folder,
  FolderTree,
} from '../types';

/** A well's folder tree, and arranging it. */
export const foldersApi = {
  /** The well's folder tree, already nested, with document counts attached. */
  tree: (wellId: number) => request<FolderTree>(`/wells/${wellId}/folders`),

  /**
   * Arranging the tree — the superadmin's job. The server checks the role
   * again; hiding the buttons is a courtesy, not the guard.
   */
  create: (wellId: number, body: { name: string; parentId?: number | null }) =>
    request<Folder>(`/wells/${wellId}/folders`, {
      method: 'POST',
      body: JSON.stringify({ name: body.name, parentId: body.parentId ?? null }),
    }),

  rename: (folderId: number, name: string) =>
    request<Folder>(`/folders/${folderId}`, {
      method: 'PATCH',
      body: JSON.stringify({ name }),
    }),

  /**
   * What the folder is for, in the superadmin's words. Saving it puts the
   * folder's documents back in the reading queue on the server, because every
   * piece read from them carries this text.
   */
  describe: (folderId: number, description: string) =>
    request<Folder>(`/folders/${folderId}`, {
      method: 'PATCH',
      body: JSON.stringify({ description }),
    }),

  remove: (folderId: number) =>
    request<void>(`/folders/${folderId}`, { method: 'DELETE' }),
};
